<template>
  <Layout
    :assetType="assetType"
    :asset="asset"
    active="configure"
    :title="`Clausify Use Terms`"
  >
    <div class="flex-grow-1 flex-column d-flex py-5 bg-light flex-shrink-0">

      <Configure
        :assetType="assetType"
        :asset="asset"
        :review="false"
        :showActions="false"
        :definitions="definitions"
      />

    </div>
  </Layout>
</template>

<script>
import Layout from '@/Shared/Layout';
import Configure from './Asset/Contract/Configure';

export default {

  components: {
    Layout,
    Configure,
  },

  props: {
    assetType: Object,
    assetTemplate: Object,
    definitions: Array,
  },

  data() {
    return {
      asset: {
        signatures: [],
        contract: {
          contract: this.assetTemplate.template,
          blocks: []
        }
      }
    };
  },
};
</script>
